import styled from 'styled-components'
import { Link } from 'gatsby'
import { DEVICE } from '../../util/constants'

export const HeaderContainer = styled.div`
  @media ${DEVICE.tabletL} {
    display: grid;
    grid-template-columns: 1fr repeat(10, 1fr) 1fr;
    height: unset;
    width: unset;
    max-width: 1317px;
    margin-top: 40px;
  }
`

export const Header = styled.div`
  /* display: none; */

  @media ${DEVICE.tabletL} {
    grid-column: 2 / 12;
    display: grid;
    grid-template-columns: max-content 1fr;
  }
`

export const LogoLinkContainer = styled(Link)`
  display: none;

  @media ${DEVICE.tabletL} {
    display: unset;
    grid-column: 1;
  }
`

export const HelplineDonateContainer = styled.div`
  display: grid;
  grid-template-columns: 7.5fr 4.5fr;
  width: 100vw;
  height: 60px;

  @media ${DEVICE.tabletL} {
    width: unset;
    height: unset;
    grid-template-columns: unset;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    grid-column: 2;
  }

  @media ${DEVICE.laptopS} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
`

// TODO this is super similar to instance of same in SubNav, make it common/shared w/ props for variants
export const Helpline = styled.div`
  user-select: none;
  background-color: var(--content-background-light);
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.7;
  letter-spacing: 0.02em;
  color: var(--content-background-dark-blue);
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    color: var(--highlight-blue);
    text-decoration-line: none;

    :hover {
      cursor: pointer;
      color: var(--graphic-accent-purple-1);
      text-decoration-line: underline;
    }
  }

  @media ${DEVICE.tabletL} {
    background-color: unset;
    font-weight: 600;
    line-height: 1;
    font-size: 1.5rem;
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.laptopS} {
    line-height: 1;
    padding-right: 34px;
    font-size: 2rem;
  }
`

// TODO this is super similar to instance of same in SubNav, make it common/shared w/ props for variants
export const DonateButton = styled.a`
  text-decoration-line: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  font-weight: bold;
  line-height: 1.7;
  color: var(--content-background-light);
  background-color: var(--highlight-blue);

  @media ${DEVICE.tabletL} {
    border: 2px solid var(--highlight-blue);
    border-radius: 5px;
    width: 110px;
    height: 50px;
    font-size: 1.5rem;
    font-weight: 600;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: 0.02em;
    background: transparent;
    color: var(--content-background-dark-blue);
    background-color: unset;

    :hover {
      cursor: pointer;
      background: var(--highlight-blue);
      color: var(--content-background-light);
    }
  }

  @media ${DEVICE.laptopS} {
    font-size: 2rem;
    width: 160px;
    height: 76px;
  }
`
